import React from 'react'

import ConnectWalletModal from '@/containers/connect-wallet-modal'
import { NftTheme } from '@/containers/home/swap-form/NftTheme'
import { useShowWalletModal, useWalletModalActions } from '@/store'

import { Outlet } from 'react-router-dom'

import { HeaderV2 } from './HeaderV2'

const LayoutContent: React.FC = () => {
  const { setShowWalletModal } = useWalletModalActions()
  const showWalletModal = useShowWalletModal()

  return (
    <>
      <div className='min-h-screen flex flex-col md:bg-optimex bg-cover bg-[center_50%] bg-no-repeat text-primary font-dm'>
        <NftTheme />

        <HeaderV2 />
        <main className='mx-auto max-w-7xl w-full py-8 flex-1 px-4 md:px-0'>
          <Outlet />
        </main>
      </div>

      <ConnectWalletModal isOpen={showWalletModal} onClose={() => setShowWalletModal({ show: false })} />
    </>
  )
}

export default LayoutContent
